/**
 * Minimal date parsing utility.
 * Supports limited formats, supporting only "dd", "mm" and "yyyy" and format must match exactly date string.
 * @param {string} dateStr date as string
 * @param {string} format
 */
export const parseDate = (dateStr, format) => {
  if (!dateStr) {
    return null;
  }

  const ddIdx = format.indexOf('dd');
  const mmIdx = format.indexOf('mm');
  const yyyyIdx = format.indexOf('yyyy');

  const year = Number.parseInt(dateStr.substr(yyyyIdx, 4), 10);
  const month = Number.parseInt(dateStr.substr(mmIdx, 2), 10) - 1;
  const date = Number.parseInt(dateStr.substr(ddIdx, 2), 10);

  return new Date(year, month, date);
};

export const formatDate = (locale, date, format) => {
  if (format === "MMM yyyy") {
    return new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric' }).format(date);
  } else {
    const year = new Intl.DateTimeFormat(locale, { year: 'numeric' }).format(date);
    const month = new Intl.DateTimeFormat(locale, { month: '2-digit' }).format(date);
    const day = new Intl.DateTimeFormat(locale, { day: '2-digit' }).format(date);
    if (format === 'MM-dd-yyyy') {
      return `${month}-${day}-${year}`;
    } else {
      // default dd.MM.yyyy
      return `${day}.${month}.${year}`;
    }
  }
};
